module.exports = __webpack_public_path__ + "img/cashback.16affd4e.png";